import { EVENT } from "@/constants/event";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import useRequest from "@/utils/useReq";
import { useDebounceFn } from "ahooks";
import { Button, Form } from "antd";
import { useEffect, useRef, useState } from "react";
import {
  createCollections,
  delBoard,
  getCollections,
  updateBoard,
} from "../../../services";
import HBInput from "../../HBInput";
import AddSelect from "../../HBInput/addSelect";
import HBMessage from "../../HBMessage";
import SwitchTransition from "../../Transition/switch";
import { CoverImg, SettingCover } from "../cover";
import styles from "../form.module.less";
import CategoriesSelect from "../shared/CategoriesSelect";
import PrivateRadio from "../shared/PrivateRadio";
import rules from "../shared/rules";

// 修改表单
export default function Editor({
  board,
  isPro,
  categories,
  onOk,
  onCancel,
  onUpdate,
  onDelete,
  refresh,
  ...props
}) {
  const user = useAppStore(({ user }) => user);
  const formref = useRef(null);
  const [page, setPage] = useState(0);
  const boardId = board.board_id;
  const [loading, setLoading] = useState(false);

  const { run: onFinish } = useDebounceFn(
    async (values) => {
      setLoading(true);
      const data = await updateBoard({
        ...values,
        title: values.title.trim(),
        description: (values.description || "").trim(),
        board_id: boardId,
        is_private: values.is_private ? "1" : "0",
        category_id: values.category,
        collection_id: values.collection_id || null,
      });

      setLoading(false);

      if (data.err) {
        return;
      }
      onOk && onOk(data.board);
      onUpdate && onUpdate(data.board);
      window.dispatchEvent(
        new CustomEvent(EVENT.BOARDLIST_DATA_UPDATE, {
          detail: { board: data.board },
        })
      );
      HBMessage.success("画板修改成功");
      useAppStore.getState().refreshLastBoards();
    },
    {
      wait: 300,
      leading: true,
    }
  );

  useEffect(() => {
    onUpdate && onUpdate(board);
  }, [onUpdate, board]);
  const upadteCover = async () => {
    const { onPageChange } = props;
    setPage(0);
    onPageChange && onPageChange(0, "修改画板");
    try {
      let data = await refresh();
      if (data?.board_id) {
        window.dispatchEvent(
          new CustomEvent(EVENT.BOARDLIST_DATA_UPDATE, {
            detail: { board: data },
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <SwitchTransition switchKey={page} duration={350}>
      {page === 0 ? (
        <Form
          ref={formref}
          className={styles.form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={board}
          autoComplete="off"
          onFinish={onFinish}
        >
          <CoverImg
            board={board}
            onClick={() => {
              setPage(1);
              props.onPageChange && props.onPageChange(1, "设置封面");
            }}
          />
          <Form.Item
            name="title"
            wrapperCol={{ flex: 1 }}
            rules={rules.title}
            style={{
              marginBottom: "12px",
            }}
          >
            <HBInput placeholder="标题" autoFocus />
          </Form.Item>

          <Form.Item
            name="description"
            wrapperCol={{ flex: 1 }}
            rules={rules.description}
          >
            <HBInput placeholder="描述" type="textarea" />
          </Form.Item>

          <Form.Item
            name="collection_id"
            wrapperCol={{ flex: 1 }}
            rules={rules.collection_id}
            style={{
              marginBottom: "12px",
            }}
          >
            <CollectionSelect user={board.user} />
          </Form.Item>

          <Form.Item
            name="category"
            wrapperCol={{ flex: 1 }}
            rules={rules.category}
            style={{
              marginBottom: "12px",
            }}
          >
            <CategoriesSelect categories={categories} />
          </Form.Item>

          <Form.Item
            name="is_private"
            wrapperCol={{ flex: 1 }}
            valuePropName="checked"
          >
            <PrivateRadio isPro={isPro} disabled={board?.is_private === 1} />
          </Form.Item>

          <Form.Item noStyle>
            <div className="vertical-center">
              <div
                className={styles.deleteBtn}
                onClick={() => {
                  props.onSwitch &&
                    props.onSwitch(1, {
                      title: "删除确认",
                      content: (
                        <div className={styles.deleteText}>
                          确定删除画板吗？删除后画板内的所有采集都会被删除。删除后
                          7 天内可以在
                          <a
                            href={`/user/${user?.urlname}/recycle`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            回收站
                          </a>
                          恢复画板。
                        </div>
                      ),
                      onCancel() {
                        props.onSwitch(0);
                      },
                      async onOk() {
                        const data = await delBoard(boardId);
                        if (data.err) {
                          return;
                        }
                        HBMessage.success("删除成功");
                        onDelete();
                        onCancel(board);
                        const lastBoards = await useAppStore
                          .getState()
                          .refreshLastBoards();
                        if (lastBoards) {
                          try {
                            window.localStorage.setItem(
                              LOCAL_STORAGE_KEY.UPDATE_LAST_BOARDS,
                              JSON.stringify(lastBoards)
                            );
                          } catch (e) {
                            console.error("设置更新最近采集失败");
                          }
                        }
                      },
                    });
                }}
              >
                删除画板
              </div>
              <div style={{ flex: 1, textAlign: "right" }}>
                <Button
                  type="text"
                  style={{ marginRight: "8px" }}
                  onClick={() => {
                    onCancel && onCancel(board);
                  }}
                >
                  取消
                </Button>
                <Button type="primary" htmlType="submit" loading={loading}>
                  确认
                </Button>
              </div>
            </div>
          </Form.Item>
        </Form>
      ) : (
        <SettingCover
          boardId={board.board_id}
          value={
            board &&
            board.extra &&
            board.extra.cover &&
            board.extra.cover.pin_id
          }
          boardTitle={board.title}
          pins={board.pins}
          cover={board.cover}
          onCancel={() => {
            setPage(0);
            props.onPageChange && props.onPageChange(0, "修改画板");
          }}
          onOk={upadteCover}
        />
      )}
    </SwitchTransition>
  );
}

/**
 * 专辑下拉框
 * @param {*} props
 * @returns
 */
function CollectionSelect(props = {}) {
  const collections = useRequest(async () => {
    if (props.user?.user_id) {
      const result = await getCollections(props.user?.user_id);
      return result.collections;
    } else {
      return [];
    }
  });

  const options = (collections.data || []).map((el) => ({
    value: el.collection_id,
    label: el.title,
  }));

  return (
    <AddSelect
      {...props}
      placeholder="专辑"
      emptyText="尚无专辑，请输入名称以创建专辑"
      emptySearchText="点击创建专辑"
      desc="输入以筛选或创建专辑"
      options={options}
      onCreate={(searchWord) => {
        createCollections(searchWord).then(({ collection }) => {
          props.onChange(collection.collection_id);
          // 刷新下拉框数据
          collections.refresh();
        });
      }}
    />
  );
}
